import CurrencyService from './CurrencyService';
import MutationService from './MutationService';

class GoogleTagManager {

	logTransaction(raffle, reservationData, registration, deliveryService) {
		const currencyCode = CurrencyService.getCurrencyCode();
		const mutationCode = MutationService.getMutationCode();
		const itemPrice = raffle.getPrice(currencyCode);
		const deliveryPrice = deliveryService.price;
		const priceTotal = itemPrice + deliveryPrice;
		const tax = priceTotal / 121 * 21;
		const raffleSize = raffle.getSize(reservationData.sizerunId);
		const raffleSizeUs = raffleSize && raffleSize.us ? raffleSize.us.replace(',', '.') : '';
		const raffleSizeSet = raffle.getSizeSet(reservationData.sizerunId);
		const raffleSizeSetName = raffleSizeSet ? raffleSizeSet.name : '';
		const dataLayer = window.dataLayer;

		dataLayer.push({
			event: 'trackTrans',
			ecommerce: {
				currencyCode,
				purchase: {
					actionField: {
						id: registration.id,
						affiliation: 'releases.footshop.com',
						revenue: priceTotal.toFixed(2),
						tax: tax.toFixed(2),
						shipping: deliveryPrice.toFixed(2),
						dimension2: 'checkout.com', // paymentmethod
						dimension3: deliveryService.carrierName, // shipping method
						coupon: ''
					},
					products: [{ // List of productFieldObjects.
						name: raffle.getTitle(mutationCode),
						id: raffle.id+'_'+ raffleSizeUs,
						price: itemPrice.toFixed(2),
						brand: raffle.brand,
						category: raffleSizeSetName,
						variant: raffleSizeUs,
						dimension4: raffle.getSubtitle(mutationCode), // colour
						quantity: 1,
						coupon: '' // Optional fields may be omitted or set to empty string.
					}]
				}
			}
		});
	}
}

export default new GoogleTagManager();


// WEBPACK FOOTER //
// ./services/GoogleTagManager.js